import ResolutionTools from "../components/ResolutionTools/ResolutionTools.jsx";
import TransitionPreview from "../components/TransitionPreview/TransitionPreview.jsx";
import ImportAfterEffectsTemplate from "../components/ImportAfterEffectsTemplate/ImportAfterEffectsTemplate.jsx";
import ImportBeta from "../components/ImportAfterEffectsTemplate/ImportBeta.jsx";
import Rename from "../components/Rename/Rename.jsx";
import CollectFiles from "../components/CollectFiles/CollectFiles.jsx";
import DeleteFilter from "../components/DeleteFilter/DeleteFilter.jsx";
import FillPlaceholders from "../components/FillPlaceholders/FillPlaceholders.jsx";
import SplitTemplate from "../components/SplitTemplate/SplitTemplate.jsx";
import CreatePlaceholder from "../components/CreatePlaceholder/CreatePlaceholder.jsx";
import NewTemplate from "../components/NewTemplate/NewTemplate.jsx";

const COMPONENTS = {
  ResolutionTools,
  TransitionPreview,
  ImportAfterEffectsTemplate,
  ImportBeta,
  Rename,
  CollectFiles,
  DeleteFilter,
  FillPlaceholders,
  SplitTemplate,
  CreatePlaceholder,
  NewTemplate,
};

export default COMPONENTS;
